
import React from 'react';
import ActionCard from '../ActionCard/ActionCard';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { filteredRoutes } from '../../Helpers/filteredRoutes';

const MenuGrid = () => {
  const navigate = useNavigate();
  const routes = filteredRoutes();

  return (
      <Grid container spacing={4}>
        {routes.slice(1, -1).map((route, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Box
              onClick={() => navigate(route.path)}
              sx={{ cursor: 'pointer' }}
            >
              <ActionCard 
                actionImage={route.icon}
                actionDescription={route.name}
              />
            </Box>
          </Grid>
        ))}
      </Grid>
  );
};

export default MenuGrid;
